import {
    CHECKBOX_TYPE,
    CHOICE_TYPE,
    EMAIL_TYPE,
    HIDDEN_TYPE,
    NUMBER_TYPE,
    TEXT_TYPE,
    TEXTAREA_TYPE
} from "v4/data/fieldTypes";

export default function getRealFieldType(fieldData) {
    if (!fieldData) return TEXT_TYPE;

    const {type, enum_titles, widget, attr} = fieldData;

    if (attr && attr.type === 'hidden') {
        return HIDDEN_TYPE;
    }

    switch (type) {
        case 'string':
            if (widget === 'textarea') {
                return TEXTAREA_TYPE;
            }

            if (widget === 'choice-expanded') {
                return CHECKBOX_TYPE;
            }

            if (widget === 'email') {
                return EMAIL_TYPE;
            }

            return enum_titles ? CHOICE_TYPE : TEXT_TYPE;
        case 'integer':
        case 'number':
            return NUMBER_TYPE;
        case 'boolean':
            return CHECKBOX_TYPE;
        case 'array':
            return CHOICE_TYPE;
        default:
            return TEXT_TYPE;
    }
}
